//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import BusinessIcon from "@material-ui/icons/Business";
import SaveConfigurationButton from "src/components/loader/buttons/SaveConfigurationButton";

const CopyLayoutButton = (props) => {
  return (
    <SaveConfigurationButton
      label="Copy Layout"
      url="loader/copyLayout"
      icon={<BusinessIcon />}
      {...props}
    />
  );
};
export default CopyLayoutButton;
